import deepEqual from 'deep-equal';
import {IPresentation} from '../incase-domain/presentation';
import {ISlide} from '../incase-domain/slide';

export function slideIndex(pres: IPresentation, slideId: string | number): ISlide {
    if (pres.slides[slideId as unknown as number] !== undefined) {
        return pres.slides[slideId as unknown as number];
    }
    if (typeof slideId === 'string') {
        const found = pres.slides.find((slide) => slide._id === slideId);
        if (found) {
            return found;
        }
    }
    return {
        _id: '',
        name: '',
        slideBackground: '',
        slideMobileBackground: '',
        elements: [],
        appliedRules: [],
        width: '1360',
        height: '760',
        hidden: false,
        onAutoFavorite: false,
    };
}

export function areSlidesDifferent(slide1: ISlide, slide2: ISlide): boolean {
    return (
        !deepEqual(slide1.elements, slide2.elements) ||
        slide1.backgroundColor !== slide2.backgroundColor ||
        slide1.slideBackground !== slide2.slideBackground ||
        slide1.slideMobileBackground !== slide2.slideMobileBackground ||
        slide1.onAutoFavorite !== slide2.onAutoFavorite ||
        slide1.hidden !== slide2.hidden ||
        slide1.name !== slide2.name
    );
}
